import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { PhotoGallery } from './photo-gallery';

const { appAlias: alias, appName: name } = meta;

export default createApp({ alias, name }, PhotoGallery);
